import largeBanner from '../../assets/bannerImages/L.webp'
import mediumBanner from '../../assets/bannerImages/M.webp'
import smallBanner from '../../assets/bannerImages/S.webp'

import { SPECIAL_TEMPLATES } from '../../helpers/templateConfig/templateConfig'

const chineseConfig = {
  banners: {
    small: smallBanner,
    medium: mediumBanner,
    large: largeBanner,
  },

  // Add special templates that this site wants beyond the defaults
  additionalTemplates: [
    SPECIAL_TEMPLATES.CHINESE_SURNAME, // Template 2: Chinese surname page
    SPECIAL_TEMPLATES.FAMILY_TREE, // Template 16: Family tree design
    SPECIAL_TEMPLATES.GLOBAL_SURNAME, // Template 17: Global surname page
  ],
}

export default chineseConfig
